var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import * as S from './styled';
var Svg = function (_a) {
    var _b = _a.role, role = _b === void 0 ? 'img' : _b, _c = _a.type, type = _c === void 0 ? 'info' : _c, _d = _a.size, size = _d === void 0 ? 24 : _d, width = _a.width, height = _a.height, props = __rest(_a, ["role", "type", "size", "width", "height"]);
    if (!width && !height) {
        width = size;
        height = size;
    }
    return (<S.Svg xmlns='http://www.w3.org/2000/svg' role={role} type={type} width={width} height={height} {...props}/>);
};
export default styled(Svg)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
